declare module "react-native-web-linear-gradient" {
  import { ViewProps } from "react-native";
  import React from "react";

  export interface LinearGradientProps extends ViewProps {
    colors: (string | number)[];
    start?: { x: number; y: number } | undefined;
    end?: { x: number; y: number } | undefined;
    locations?: number[] | undefined;
    useAngle?: boolean | undefined;
    angleCenter?: { x: number; y: number } | undefined;
    angle?: number | undefined;
  }

  export default class LinearGradient extends React.Component<LinearGradientProps> {}
}
